<app-section
  titleSection="DÉFINITIONS"
  [isActivated]="definitions.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-definitions-read-mode [definitions]="definitions">
    </app-definitions-read-mode>
  </div>

  <div edit-mode>
    <app-definitions-edit-mode
      [definitions]="definitions"
      (definitionsChanged)="onDefinitionsChanged($event)"
    >
    </app-definitions-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
